import { Box, Stack, Typography } from "@mui/material";
import React from "react";
// import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
const FooterSection = () => {
  return (
    <>
      {/* <Header /> */}
      <main>
        <Stack
          sx={{
            // height: { xl: "100vh" },
            display: "flex",
            flexDirection: { xl: "row" },
            justifyContent: "center",
            // border: "1px solid blue",
          }}
        >
          {/* <Stack sx={{ border: "1px solid red", width: { xl: "70%" } }}> */}
          <Stack
            sx={{
              // border: "1px solid blue",
              height: { xl: "14%" },
              dispaly: "flex",
              flexDirection: { xl: "column" },
            }}
          >
            <Stack
              sx={{
                // border: "2px solid red",
                height: { xl: "70%" },
                dispaly: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {/* <Typography
                sx={{
                  fontSize: { xl: "40px" },
                  fontFamily:
                    "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                  fontWeight: 600,
                }}
              >
                Term and condition
              </Typography> */}
            </Stack>
            <Stack
              sx={{
                // border: "2px solid blue",
                height: { xl: "30%" },
                dispaly: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Breadcrumbs
                aria-label="breadcrumb"
                sx={{ marginLeft: "12px" }}
              >
                {/* <Link
                    underline="hover"
                    color="inherit"
                    href="/"
                    sx={{
                      fontFamily:
                        "'__Inter_148820', '__Inter_Fallback_148820', sans-serif",
                      fontWeight: 600,
                    }}
                  >
                    Home
                  </Link>
                  <Link underline="none" color="inherit">
                    Term and condition
                  </Link> */}
              </Breadcrumbs>
            </Stack>
          </Stack>
        </Stack>
        {/* </Stack> */}
      </main >
      <Footer />
    </>
  );
};

export default FooterSection;
